<template>
  <v-container fluid fill-height>
    <Loader v-model="loading" />
    <Keyboard v-model="keyboard" />
    <TerminalUI @entrar="entrarTerminal" :empresa="empresa" :cajero="cajero" @change_ultimo="ultimoRegister = null"
      :ultimoRegister="ultimoRegister" :terminales="terminales" :usuario="usuario" v-model="terminalDialog" />
    <!-- <NIPComponent
      :empresa="empresa"
      v-model="nip"
    /> -->
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card color="grey darken-1" shaped class="login-card justify-center rounded-xl">
          <v-toolbar flat light color="secondary">
            <v-fab-transition>
              <v-tooltip color="primary" top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-if="isOnline" v-bind="attrs" v-on="on" dark right> mdi-wifi </v-icon>
                  <v-icon v-else dark v-bind="attrs" v-on="on" right> mdi-wifi-off </v-icon>
                </template>
                <span v-if="isOnline">Usted tiene internet, puede usar el sistema</span>
                <span v-else>Usted no tiene internet, no puede usar el sistema</span>
              </v-tooltip>

              

            </v-fab-transition>

             <v-fab-transition>
              <v-btn icon large color="primary" @click="abrirMenu($event)" class="mr-2">
                <v-icon>mdi-cog</v-icon>
              </v-btn>
            </v-fab-transition>  

            <v-spacer></v-spacer>
            <v-toolbar-title class="white--text text-center">Tootle TPV</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-fab-transition>
              <v-btn @click="keyboardMode" fab large absolute top right class="v-btn--example">
                <v-icon v-if="!keyboardSession">mdi-keyboard</v-icon>
                <v-icon v-else>mdi-keyboard-off</v-icon>
              </v-btn>
            </v-fab-transition>
            

          </v-toolbar>
          <v-menu
  v-model="menuConfig.visible"
  :position-x="menuConfig.x"
  :position-y="menuConfig.y"
  absolute
  offset-y
>
  <v-list dense>

    <v-list-item @click="menuAccion('admin')">
      <v-list-item-icon>
        <v-icon>mdi-account-cog</v-icon>
      </v-list-item-icon>
      <v-list-item-title>Administrador TPV</v-list-item-title>
    </v-list-item>

    <v-list-item @click="menuAccion('cuentas')">
      <v-list-item-icon>
        <v-icon>mdi-monitor</v-icon>
      </v-list-item-icon>
      <v-list-item-title>Estado de Cuenta</v-list-item-title>
    </v-list-item>

    <!-- <v-divider></v-divider>

    <v-list-item @click="menuAccion('keyboard')">
      <v-list-item-icon>
        <v-icon>mdi-keyboard</v-icon>
      </v-list-item-icon>
      <v-list-item-title>Teclado Virtual</v-list-item-title>
    </v-list-item>

    <v-divider></v-divider>

    <v-list-item @click="menuAccion('logout')">
      <v-list-item-icon>
        <v-icon color="red">mdi-logout</v-icon>
      </v-list-item-icon>
      <v-list-item-title class="red--text">
        Cerrar sesión
      </v-list-item-title>
    </v-list-item>  -->

  </v-list>
</v-menu>

          <v-card-text>
            <v-form>
              <v-text-field color="secondary" name="login" label="Login" outlined dark rounded type="text"
                class="my-input" v-model="usuario.usuario" @click="showKeyboard" @keydown.space.prevent></v-text-field>
              <v-text-field color="secondary" id="password" dark name="password" label="Password" outlined rounded
                type="password" v-model="usuario.password" @click="showKeyboard"></v-text-field>
            </v-form>
            <v-container>
              <v-row>
                <v-btn rounded block dark color="secondary" @click="login">Login</v-btn>
              </v-row>
              <br /><br />
              <v-row>
                <v-btn rounded block dark color="secondary" @click="nipLogin">NIP</v-btn>
              </v-row>
              <br />
              <!-- <v-row>
                <v-col md="6">
                  <v-btn rounded block dark color="primary" @click="admin()">
                    <v-icon left dark> mdi-account-settings </v-icon>
                    Administrador TPV</v-btn
                  >
                </v-col>
                <v-col md="6">
                  <v-btn rounded block dark color="red" @click="youtube()">
                    <v-icon left dark> mdi-youtube </v-icon>
                    Videos</v-btn
                  >
                </v-col>
              </v-row> -->
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Keyboard from "../components/Keyboard.vue";
import Cookies from "js-cookie";
import { POSRegisterFunctions } from "../controllers/POSController";
import {
  Usuario,
  TerminalDialog,
  Session,
  Toast,
  ErrorWeb,
} from "../controllers/DataController.js";
import Loader from "../components/Loader.vue";
import { db } from '../db';
import TerminalUI from "../components/TerminalComponent.vue";
import { VueOfflineMixin } from 'vue-offline'
//import FirmaAutorizacion from "../components/FirmaAutorizacionComponent.vue";

// import NIPComponent from '../components/NIPComponent.vue';

export default {
  mixins: [VueOfflineMixin],
  data() {
    return {
      keyboardSession: false,
      keyboard: {
        visible: false,
        input: null,
        
      },
      menuConfig: {
  visible: false,
  x: 0,
  y: 0,
},
      version:
        "Version: " +
        process.env.VUE_APP_RELEASE_NAME +
        " " +
        process.env.VUE_APP_RELEASE_VERSION,
      loading: false,
      terminalDialog: new TerminalDialog(),
      usuario: new Usuario(),
      registerFunctions: new POSRegisterFunctions(),
      ultimoRegister: null,
      nip: {
        isVisible: false,
        empresa: "2"
      },
      terminales: [],
      terminal: "",
      cajero: {
        intCajero: 0,
      },
      empresa: parseInt(this.$config.empresa),
      sucursal: parseInt(this.$config.sucursal),
     
    };
  },
  components: {
    Loader,
    TerminalUI,
    Keyboard,
    //FirmaAutorizacion,
    // NIPComponent,
  },
  methods: {
    showKeyboard(e) {
      if (this.keyboardSession) {
        this.keyboard.input = e.target;
        this.keyboard.visible = true;
      }
    },
    menuAccion(opcion) {
  this.menuConfig.visible = false;

  switch (opcion) {
    case "admin":
      this.$router.push("/Admin/Login");
      break;
      case "cuentas":
      this.$router.push("/EstadoCuenta");
      break;

    // case "terminal":
    //   this.terminalDialog.isVisible = true;
    //   break;

    // case "keyboard":
    //   this.keyboardMode();
    //   break;

    // case "logout":
    //   this.logout();
    //   break;
  }
},

logout() {
  Cookies.remove("POS_USER");
  Cookies.remove("POS_TERMINAL");
  Cookies.remove("POS_REGISTER_CAJA");
  Cookies.remove("POS_TIPO");

  this.$router.go(0);
},

abrirMenu(e) {
  this.menuConfig.visible = false;

  this.menuConfig.x = e.clientX;
  this.menuConfig.y = e.clientY;

  this.$nextTick(() => {
    this.menuConfig.visible = true;
  });
},
    admin() {
      this.$router.push("Admin/Login");
    },
    youtube() {
      window.location.href = "https://www.youtube.com/channel/UCheNu9ASYwNMPnSayrxnSrQ";
    },
    entrarNIP() {
      // this.nip.isVisible = true;
    },
    async entrarTerminal(seleccion) {
      this.terminal = seleccion.terminal;
      this.sucursal = seleccion.sucursal
      this.terminalDialog.isVisible = false;
      this.loading = true;
      try {
        await this.usuario.login_terminal(this.terminal);

        // * MCZ -> Guardamos terminal en cookie
        Cookies.set("POS_TERMINAL", this.terminal, { expires: 5 });
        Cookies.set("POS_SUCURSAL", this.sucursal, { expires: 5 });

        // * MCZ -> Necesitamos validar los dos registers actuales, el del usuario y el actual de terminal
        //  const REGISTER_ACTUAL = await this.registerFunctions.register_actual(
        //    this.empresa,
        //    this.terminal
        //  );
        const REGISTER_ACTUAL = await this.registerFunctions.register_actualUsuario(
          this.empresa,
          this.terminal,this.usuario.usuario
        );

        const REGISTER_ACTUAL_USUARIO = await this.usuario.register_actual(
          this.empresa,
          this.terminal
        );

        console.log("REGISTER_ACTUAL: " );
        console.log( REGISTER_ACTUAL);
        console.log("REGISTER_ACTUAL_USUARIO: ");
        console.log(REGISTER_ACTUAL_USUARIO);

       
        if (seleccion.apertura) {
          // * MCZ -> El usuario desea abrir caja
          if (REGISTER_ACTUAL.intPOSRegister == 0) {
            // * MCZ -> No existe registro actual, puede abrir caja
            Cookies.set("POS_TIPO", "cajero", { expires: 5 });
            this.$router.push("/Caja/1");
          } else if (
            REGISTER_ACTUAL.intPOSRegister == REGISTER_ACTUAL_USUARIO.intPOSRegister
          ) {
            // * MCZ -> Existe apertura, y es del usuario, lo mandamos directo al main
            Cookies.set("POS_REGISTER_CAJA", REGISTER_ACTUAL_USUARIO.intPOSRegister, {
              expires: 5,
            });
            Cookies.set("POS_TIPO", "cajero", { expires: 5 });
            this.$router.push("/Main");
          } 
          
          // else {
          //   // * MCZ -> Existe apertura, no es del usuario, no puede abrir, mandamos error y que entre como comandera
          //   throw (
          //     "Otro usuario tiene abierta la caja en esta terminal, no puede acceder como CAJERO. Register Actual : " +
          //     REGISTER_ACTUAL.intPOSRegister +
          //     " Register Usuario: " +
          //     REGISTER_ACTUAL_USUARIO.intPOSRegister
          //   );
          // }
        } 
        else {
          // * MCZ -> Version de comandero, no necesita tener abierta caja (usuario), pero necesita un register de terminal abierto
          if (REGISTER_ACTUAL.intPOSRegister == 0)
        {
          throw "La caja de la terminal no ha sido abierta, no se puede acceder";
          // Cookies.set("POS_REGISTER_CAJA", REGISTER_ACTUAL.intPOSRegister, {
          //     expires: 5,
          //   });
          //   if (seleccion.cajero) Cookies.set("POS_TIPO", "cajero", { expires: 5 });
          //   else Cookies.set("POS_TIPO", "comandero", { expires: 5 });
          //   this.$router.push("/Main");
        }
            
          
          else {
            // * MCZ -> Existe apertura, lo mandamos directo al main
            Cookies.set("POS_REGISTER_CAJA", REGISTER_ACTUAL.intPOSRegister, {
              expires: 5,
            });
            if (seleccion.cajero) Cookies.set("POS_TIPO", "cajero", { expires: 5 });
            else Cookies.set("POS_TIPO", "comandero", { expires: 5 });
            this.$router.push("/Main");
          }
        }
      } catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
      } finally {
        this.loading = false;
      }
    },
    keyboardMode() {
      this.keyboardSession = !this.keyboardSession;
      let session = new Session();
      session.setKeyboard(this.keyboardSession);
    },
    async login() {
      this.loading = true;
      try {
        //Se limpia el cache al entrar al hacer login
        await db.articulos.clear();
      await db.grupos.clear();
      await db.tiposPago.clear();
      await db.motivosDescuento.clear();
      await db.motivosDevolucion.clear();
      await db.colonias.clear();
      await db.impresoras.clear();
      await db.meseros.clear();
      await db.terminalPago.clear();
      await db.tiposVenta.clear();
      await db.clientes.clear();
      await db.mesas.clear();
      await db.repartidores.clear();
      await db.articulo_configuraciones.clear();
        console.log(this.empresa)
        // * MCZ -> Logeamos
        this.usuario.usuario.toUpperCase();
        await this.usuario.login();
        // * MCZ -> Ya validado guardamos informacion en cookies
        Cookies.set("POS_USER", this.usuario.usuario.trim(), { expires: 5 });
        //Cookies.set("POS_EMPRESA", this.empresa, { expires: 5 });
        // Cookies.set("POS_SUCURSAL", this.sucursal, { expires: 5 });
        // * MCZ -> Traemos las terminales que puede usar y la informacion del TPV del Usuario
       this.terminales = await this.usuario.terminales(this.usuario.usuario);
        //console.log("La sucursal de la terminal es: " + this.terminales);
        console.log(this.terminales);              // muestra el objeto completo
console.log(JSON.stringify(this.terminales, null, 2)); // muestra como JSON bien formateado

        Cookies.set("POS_EMPRESA",this.terminales[0].intEmpresa , { expires: 5 });

        this.cajero = await this.usuario.cajero(this.usuario.usuario);
        this.ultimoRegister = await this.usuario.ultimo_register(new Session());
        this.terminalDialog.isVisible = true;
      } catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
      } finally {
        this.loading = false;
      }
    },
    async nipLogin() {
      this.loading = true;
      try {
        // * MCZ -> Logeamos
        await this.usuario.login();
        // * MCZ -> Ya validado guardamos informacion en cookies
        Cookies.set("POS_USER", this.usuario.usuario.toUpperCase(), { expires: 5 });
        Cookies.set("POS_EMPRESA", this.empresa, { expires: 5 });
        // Cookies.set("POS_SUCURSAL", this.sucursal, { expires: 5 });
        // * MCZ -> Traemos las terminales que puede usar y la informacion del TPV del Usuario
      //  this.terminales = await this.usuario.terminales(this.usuario.usuario);
        // this.cajero = await this.usuario.cajero(this.usuario.usuario);
        // this.ultimoRegister = await this.usuario.ultimo_register(new Session());
        console.log("entro nip")
        this.nip.isVisible = true;
      } catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
      } finally {
        this.loading = false;
      }
    },
    async PrintCorteGlobal(global,fecha) {
      this.loading = true;
      try {
        global.pagos= await this.registerFunctions.pagosGlobal();
          this.datacierreCorteGlobal =  await this.registerFunctions.corteGlobal(0,fecha);
        // console.log(fecha)
          console.log(global.pagos)
          global.dblVenta=this.datacierreCorteGlobal.dblVenta,
          global.dblVentaSinImpuesto=this.datacierreCorteGlobal.dblVentaSinImpuesto,
          global.intEnvios=this.datacierreCorteGlobal.intEnvios,
          global.dblEnvios=this.datacierreCorteGlobal.dblEnvios,
          global.dblVentaConImpuesto=this.datacierreCorteGlobal.dblVentaConImpuesto,
          global.intTotalOrdenesVenta=this.datacierreCorteGlobal.intTotalOrdenesVenta,
          global.intTotalPlatillosVenta=this.datacierreCorteGlobal.intTotalPlatillosVenta,
          global.intPromCta=this.datacierreCorteGlobal.intPromCta,
          global.dblPromCta=this.datacierreCorteGlobal.dblPromCta,
          global.intCortesiaCta=this.datacierreCorteGlobal.intCortesiaCta,
          global.dblCortesiaCta=this.datacierreCorteGlobal.dblCortesiaCta,
          global.intCortesiaPlat=this.datacierreCorteGlobal.intCortesiaPlat,
          global.dblCortesiaPlat=this.datacierreCorteGlobal.dblCortesiaPlat,
          global.intCancelacionCta=this.datacierreCorteGlobal.intCancelacionCta,
          global.dblCancelacionCta=this.datacierreCorteGlobal.dblCancelacionCta,
          global.intCancelacionPlat=this.datacierreCorteGlobal.intCancelacionPlat,
          global.dblCancelacionPlat=this.datacierreCorteGlobal.dblCancelacionPlat,
          global.intDescuentoCta=this.datacierreCorteGlobal.intDescuentoCta,
          global.dblDescuentoCta=this.datacierreCorteGlobal.dblDescuentoCta,
          global.intDescuentoPlat=this.datacierreCorteGlobal.intDescuentoPlat,
          global.dblDescuentoPlat=this.datacierreCorteGlobal.dblDescuentoPlat,
          global.intDevolucionCta=this.datacierreCorteGlobal.intDevolucionCta,
          global.dblDevolucionCta=this.datacierreCorteGlobal.dblDevolucionCta,
          global.intDevolucionPlat=this.datacierreCorteGlobal.intDevolucionPlat,
          global.dblDevolucionPlat=this.datacierreCorteGlobal.dblDevolucionPlat,
          global.intOrdenesDomicilio=this.datacierreCorteGlobal.intOrdenesDomicilio,
          global.dblTotalDomicilio=this.datacierreCorteGlobal.dblTotalDomicilio,
          global.intOrdenesLLevar=this.datacierreCorteGlobal.intOrdenesLLevar,
          global.dblTotalLLevar=this.datacierreCorteGlobal.dblTotalLLevar,
          global.intOrdenesMesa=this.datacierreCorteGlobal.intOrdenesMesa,
          global.dblTotalMesa=this.datacierreCorteGlobal.dblTotalMesa,
          global.dblFondoCaja=this.datacierreCorteGlobal.dblFondoCaja,
          global.dblEntregaReal=this.datacierreCorteGlobal.dblEntregaReal,
          global.dblDiferencia=this.datacierreCorteGlobal.dblDiferencia,
          global.intRetiroObligatorio=this.datacierreCorteGlobal.intRetiroObligatorio,
          global.dblRetiroObligatorio=this.datacierreCorteGlobal.dblRetiroObligatorio,
          global.dblComisiones=this.datacierreCorteGlobal.dblComisiones,
          global.intIntentos=this.datacierreCorteGlobal.intIntentos,
          global.dblCompras=this.datacierreCorteGlobal.dblCompras
          global.intOrdenesRappi=this.datacierreCorteGlobal.intOrdenesRappi,
          global.dblTotalRappi=this.datacierreCorteGlobal.dblTotalRappi
          global.intOrdenesUber=this.datacierreCorteGlobal.intOrdenesUber,
          global.dblTotalUber=this.datacierreCorteGlobal.dblTotalUber
          global.intOrdenesDidi=this.datacierreCorteGlobal.intOrdenesDidi,
          global.dblTotalDidi=this.datacierreCorteGlobal.dblTotalDidi
          
          if(this.config_21.valor)
            this.printerGlobal.event = "corteGlobalDicex";
            else
             this.printerGlobal.event = "corteGlobal";

            
            this.printerGlobal.visible = true;
            this.printerGlobal.printable =global;
            this.printerGlobal.after_event = true;

      } catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
      } finally {
        this.loading = false;
      }
    },
    
  },
  mounted() {
    console.log("entro",this.empresa  )
    this.keyboardSession = new Session().keyboard;
    this.$on('offline', () => {
        alert('No tiene internet! Usted no podra logearse')
    })
  },
};
</script>

<style>
.login-card {
  opacity: 0.8;
}

my-input input{
  text-transform: uppercase
}
/* #app {
  background-image: url("https://i1.wp.com/www.horatope.com/wp-content/uploads/2016/11/square-biz-in-a-box.jpg?ssl=1");
  background-size: cover;
  overflow: hidden;
} */
</style>
